import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import styled from "styled-components";
import logo from "../assets/logo.svg";

const StyledNav = styled(Navbar)`
  background-color: white;
  border-bottom: 2px solid #2b4ff4;
  box-shadow: 0 10px 10px -5px rgba(0, 0, 0, 0.1);
`;

//#2b4ff4
function BrandExample() {
  return (
    <>
      <StyledNav variant="light" sticky="top">
        <Container style={{ marginLeft: "0px" }}>
          <Navbar.Brand href="#home">
            <img
              alt=""
              src={logo}
              width="30"
              height="30"
              className="d-inline-block align-top"
            />{" "}
            Sales Planning Autopilot
          </Navbar.Brand>
        </Container>
      </StyledNav>
    </>
  );
}

export default BrandExample;
